import { Box, IconButton, Typography } from "@mui/material"
import { useTranslation } from "react-i18next"
import { icons } from "../../../../../../../../utils/icons"
import { useGoBackToListStyles } from "./goBackToListStyles"
import { useReportFoliosDetailContext } from "../../hooks/useReportFoliosContext"

const GoBackToList = ({ exit}:{exit?:boolean}) => {
    const { t } = useTranslation()
    const styles = useGoBackToListStyles()
    const { changeReportFolio, handleExit, confirmReturn} = useReportFoliosDetailContext()

    return (
        <Box sx={styles.flex}>
            <IconButton
                sx={styles.goBack}
                onClick={() => {
                    if (changeReportFolio && !exit) {
                        confirmReturn()
                    } else {
                        handleExit()
                    }
                }}
            >
                {icons('arrow-left-fill')}
            </IconButton>

            <Typography sx={styles.goBackText}>{t('general.goBackToTheList')}</Typography>
        </Box>
    )
}


export { GoBackToList }